<script setup>
import { computed } from 'vue'
import { Badge } from '@drama/ui'

import AuditPerson from './AuditPerson.vue'
import { useAuditText } from './audit-text.js'
import { asArray, characterRecord, placeName } from './run-observer.js'

const props = defineProps({
  pack: { type: Object, required: true },
  branch: { type: Object, required: true },
  sources: { type: Map, required: true },
})
const characterId = defineModel('characterId', { type: String, default: '' })

const { tr } = useAuditText()
const rows = computed(() => asArray(props.pack.characters).map((person) => ({
  person,
  initial: [...(person.name || '?')][0],
  location: placeName(props.pack, props.branch.state?.positions?.[person.id]),
  record: characterRecord(props.pack, props.branch, props.sources, person.id),
})))
// 没选或选中的人物不在这局里时，落到玩家，再落到第一位。
const selected = computed(() => rows.value.find((row) => row.person.id === characterId.value) ||
  rows.value.find((row) => row.person.id === props.pack.player_id) ||
  rows.value[0] ||
  null)
</script>

<template>
  <div class="au-people">
    <nav class="au-card au-roster" :aria-label="tr('characters.list')">
      <button
        v-for="row in rows"
        :key="row.person.id"
        type="button"
        class="au-roster__item"
        :class="{ 'is-selected': row.person.id === selected?.person.id }"
        :aria-current="row.person.id === selected?.person.id ? 'true' : undefined"
        :data-testid="`character-${row.person.id}`"
        @click="characterId = row.person.id"
      >
        <span class="au-avatar" aria-hidden="true">{{ row.initial }}</span>
        <span class="au-roster__text">
          <strong>{{ row.person.name }}</strong>
          <small>{{ row.location }}</small>
        </span>
        <Badge size="sm" :variant="row.record.open_threads.length ? 'warning' : 'neutral'">{{ tr('characters.openCount', { count: row.record.open_threads.length }) }}</Badge>
      </button>
      <p v-if="!rows.length" class="au-empty">{{ tr('empty') }}</p>
    </nav>
    <AuditPerson
      v-if="selected"
      :pack="pack"
      :branch="branch"
      :sources="sources"
      :person="selected.person"
      :record="selected.record"
      :initial="selected.initial"
      :location="selected.location"
    />
  </div>
</template>
